

<template>
  <div>
    <Pane />

    <a-card class="container">
      <a-row>
        <a-col :span="22">
          <a-form-model
            :colon="false"
            :model="form"
            layout="inline"
            @keyup.enter.native="query"
          >
            <a-form-model-item>
              <a-input
                v-model="form.name"
                placeholder="姓名"
                style="width: 150px"
              ></a-input>
            </a-form-model-item>
            <a-form-model-item>
              <a-input
                v-model="form.contact"
                placeholder="联系方式"
                style="width: 150px"
              ></a-input>
            </a-form-model-item>

            <a-form-model-item>
              <a-space>
                <a-button @click="query" type="primary">查询</a-button>
                <a-button @click="reset">重置</a-button>
              </a-space>
            </a-form-model-item>
          </a-form-model>
        </a-col>
      </a-row>

      <Padding />

      <a-table
        bordered
        :data-source="list"
        :loading="loading"
        @change="onChange"
        :pagination="{
          total,
          current,
          pageSize,
          showTotal: (total) => `共 ${total} 条记录`,
        }"
      >
        <a-table-column title="姓名" data-index="name"> </a-table-column>
        <a-table-column title="联系方式" data-index="contact"> </a-table-column>
        <a-table-column title="意见" data-index="remark"> </a-table-column>
        <a-table-column title="创建时间" data-index="createAt" align="center">
        </a-table-column>

        <a-table-column title="状态" align="center">
          <template slot-scope="text">
            <a-badge color="#f00" v-if="text.status === 0" text="未处理" />
            <a-badge color="#1890ff" v-if="text.status === 1" text="已处理" />
          </template>
        </a-table-column>

        <a-table-column title="操作" align="center" width="140px">
          <template slot-scope="text">
            <a-space>
              <a
                href="#"
                @click.prevent="dispose(text)"
                v-if="text.status === 0"
                >已处理</a
              >
              <!-- <a href="#" class="danger" @click="deleteText(text)">删除</a> -->
            </a-space>
          </template>
        </a-table-column>
      </a-table>
    </a-card>
  </div>
</template>


<script>
import watermark from "@/mixins/watermark";
import { fetchList, read, remove } from "@/api/website/feedback";

export default {
  mixins: [watermark],

  data() {
    return {
      form: {},

      loading: false,
      current: 1,
      pageSize: 10,
      list: [],
      total: 0,
    };
  },

  mounted() {
    this.getList();
  },

  methods: {
    getList() {
      const { current, pageSize, form } = this;
      this.loading = true;
      fetchList({
        pageNum: current,
        pageSize: pageSize,
        ...form,
      })
        .then((res) => {
          if (Array.isArray(res.list)) {
            this.list = Object.freeze(res.list);
            this.total = res.totalSize;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onChange(pagination) {
      this.current = pagination.current;
      this.pageSize = pagination.pageSize;
      this.getList();
    },

    query() {
      this.current = 1;
      this.getList();
    },
    reset() {
      this.form = {};
      this.current = 1;
      this.getList();
    },

    dispose(text) {
      const that = this;
      this.$confirm({
        title: "确认已处理了这条反馈吗？",
        onOk() {
          read({
            ...text,
            status: 1,
          }).then(() => {
            that.getList();
          });
        },
      });
    },

    deleteText(text) {
      const that = this;
      this.$confirm({
        title: "确认要删除这条反馈吗？",
        onOk() {
          remove({
            id: text.id,
          }).then(() => {
            that.getList();
          });
        },
      });
    },
  },
};
</script>